export const commonConstants = {
  LANDING_FORM_REQUEST: 'COMMON/LANDING_FORM_REQUEST',
  LANDING_FORM_SUCCESS: 'COMMON/LANDING_FORM_SUCCESS',
  LANDING_FORM_FAILURE: 'COMMON/LANDING_FORM_FAILURE',

  COUNTER_NOTIF_REQUEST: 'COMMON/COUNTER_NOTIF_REQUEST',
  COUNTER_NOTIF_SUCCESS: 'COMMON/COUNTER_NOTIF_SUCCESS',
  COUNTER_NOTIF_FAILURE: 'COMMON/COUNTER_NOTIF_FAILURE',

  CLEAR_NOTIFICATION_COUNT: 'COMMON/CLEAR_NOTIFICATION_COUNT',

  COUNTER_MESSAGE_REQUEST: 'COMMON/COUNTER_MESSAGE_REQUEST',
  COUNTER_MESSAGE_SUCCESS: 'COMMON/COUNTER_MESSAGE_SUCCESS',
  COUNTER_MESSAGE_FAILURE: 'COMMON/COUNTER_MESSAGE_FAILURE',

  SET_IS_MOBILE: 'COMMON/SET_IS_MOBILE',
  SET_IS_TABLET: 'COMMON/SET_IS_TABLET',

  GET_MEMBER_INTEREST_REQUEST: 'COMMON/GET_MEMBER_INTEREST_REQUEST',
  GET_MEMBER_INTEREST_SUCCESS: 'COMMON/GET_MEMBER_INTEREST_SUCCESS',
  GET_MEMBER_INTEREST_FAILURE: 'COMMON/GET_MEMBER_INTEREST_FAILURE',

  GET_SUBSCRIPTION_REQUEST: 'COMMON/GET_SUBSCRIPTION_REQUEST',
  GET_SUBSCRIPTION_SUCCESS: 'COMMON/GET_SUBSCRIPTION_SUCCESS',
  GET_SUBSCRIPTION_FAILURE: 'COMMON/GET_SUBSCRIPTION_FAILURE',

  GET_PAYMENTMANAGEURL_REQUEST: 'COMMON/GET_PAYMENTMANAGEURL_REQUEST',
  GET_PAYMENTMANAGEURL_SUCCESS: 'COMMON/GET_PAYMENTMANAGEURL_SUCCESS',
  GET_PAYMENTMANAGEURL_FAILURE: 'COMMON/GET_PAYMENTMANAGEURL_FAILURE',

  CANCEL_SUBSCRIPTION_REQUEST: 'SUBSCRIPTION/CANCEL_SUBSCRIPTION_REQUEST',
  CANCEL_SUBSCRIPTION_SUCCESS: 'SUBSCRIPTION/CANCEL_SUBSCRIPTION_SUCCESS',
  CANCEL_SUBSCRIPTION_FAILURE: 'SUBSCRIPTION/CANCEL_SUBSCRIPTION_FAILURE',

  POPIN_OPEN: 'COMMON/POPIN_OPEN',
  POPIN_CLOSE: 'COMMON/POPIN_CLOSE',

  FILE_CREATION_REMOVE: 'COMMON/FILE_CREATION_REMOVE',

  FILES_CREATION_REQUEST: 'COMMON/FILES_CREATION_REQUEST',
  FILES_CREATION_SUCCESS: 'COMMON/FILES_CREATION_SUCCESS',
  FILES_CREATION_FAILURE: 'COMMON/FILES_CREATION_FAILURE',

  START_FILE_PROCESSING: 'COMMON/START_FILE_PROCESSING',

  CLEAR_FILE_IDS: 'COMMON/CLEAR_FILE_IDS',

  SEARCH_INTEREST_REQUEST: 'COMMON/SEARCH_INTEREST_REQUEST',
  SEARCH_INTEREST_SUCCESS: 'COMMON/SEARCH_INTEREST_SUCCESS',
  SEARCH_INTEREST_FAILURE: 'COMMON/SEARCH_INTEREST_FAILURE',

  SUGGEST_INTEREST_REQUEST: 'COMMON/SUGGEST_INTEREST_REQUEST',
  SUGGEST_INTEREST_SUCCESS: 'COMMON/SUGGEST_INTEREST_SUCCESS',
  SUGGEST_INTEREST_FAILURE: 'COMMON/SUGGEST_INTEREST_FAILURE',

  UPDATE_INTETESTS_AFTER_SELECTION: 'COMMON/UPDATE_INTETESTS_AFTER_SELECTION',
  UPDATE_SELECTED_INTERESTS: 'COMMON/UPDATE_SELECTED_INTERESTS',

  GET_CURRENCIES_REQUEST: 'COMMON/GET_CURRENCIES_REQUEST',
  GET_CURRENCIES_SUCCESS: 'COMMON/GET_CURRENCIES_SUCCESS',
  GET_CURRENCIES_FAILURE: 'COMMON/GET_CURRENCIES_FAILURE',

  GET_LANGUAGES_REQUEST: 'COMMON/GET_LANGUAGES_REQUEST',
  GET_LANGUAGES_SUCCESS: 'COMMON/GET_LANGUAGES_SUCCESS',
  GET_LANGUAGES_FAILURE: 'COMMON/GET_LANGUAGES_FAILURE',

  GET_GROUPS_BY_ORGID_REQUEST: 'COMMON/GET_GROUPS_BY_ORGID_REQUEST',
  GET_GROUPS_BY_ORGID_SUCCESS: 'COMMON/GET_GROUPS_BY_ORGID_SUCCESS',
  GET_GROUPS_BY_ORGID_FAILURE: 'COMMON/GET_GROUPS_BY_ORGID_FAILURE',

  GET_TIMEZONE_BY_LAT_LONG_REQUEST: 'COMMON/GET_TIMEZONE_BY_LAT_LONG_REQUEST',
  GET_TIMEZONE_BY_LAT_LONG_SUCCESS: 'COMMON/GET_TIMEZONE_BY_LAT_LONG_SUCCESS',
  GET_TIMEZONE_BY_LAT_LONG_FAILURE: 'COMMON/GET_TIMEZONE_BY_LAT_LONG_FAILURE',
  CLEAR_TIMEZONE: 'COMMON/CLEAR_TIMEZONE',

  GET_POPUP_COOKIE_REQUEST: 'COMMON/GET_POPUP_COOKIE_REQUEST',
  GET_POPUP_COOKIE_SUCCESS: 'COMMON/GET_POPUP_COOKIE_SUCCESS',
  GET_POPUP_COOKIE_FAILURE: 'COMMON/GET_POPUP_COOKIE_FAILURE',

  SET_POPUP_COOKIE_REQUEST: 'COMMON/SET_POPUP_COOKIE_REQUEST',
  SET_POPUP_COOKIE_SUCCESS: 'COMMON/SET_POPUP_COOKIE_SUCCESS',
  SET_POPUP_COOKIE_FAILURE: 'COMMON/SET_POPUP_COOKIE_FAILURE',

  GET_USER_LOCATION_REQUEST: 'COMMON/GET_USER_LOCATION_REQUEST',
  GET_USER_LOCATION_SUCCESS: 'COMMON/GET_USER_LOCATION_SUCCESS',
  GET_USER_LOCATION_FAILURE: 'COMMON/GET_USER_LOCATION_FAILURE',

  SET_USER_LOCATION: 'COMMON/SET_USER_LOCATION',

  ADD_USER_PAGEVIEW_REQUEST: 'COMMON/ADD_USER_PAGEVIEW_REQUEST',
  ADD_USER_PAGEVIEW_SUCCESS: 'COMMON/ADD_USER_PAGEVIEW_SUCCESS',
  ADD_USER_PAGEVIEW_FAILURE: 'COMMON/ADD_USER_PAGEVIEW_FAILURE',

  GET_TAG_USERS_REQUEST: 'COMMON/GET_TAG_USERS_REQUEST',
  GET_TAG_USERS_SUCCESS: 'COMMON/GET_TAG_USERS_SUCCESS',
  GET_TAG_USERS_FAILURE: 'COMMON/GET_TAG_USERS_FAILURE',

  SET_USER_APP_VERSION: 'COMMON/SET_USER_APP_VERSION',

  UPDATE_BANNER_DATA: 'COMMON/UPDATE_BANNER_DATA',
  CLOSE_BANNER_DATA: 'COMMON/CLOSE_BANNER_DATA',

  GET_CONVERSATIONS_LIST_REQUEST: 'COMMON/GET_CONVERSATIONS_LIST_REQUEST',
  GET_CONVERSATIONS_LIST_SUCCESS: 'COMMON/GET_CONVERSATIONS_LIST_SUCCESS',
  GET_CONVERSATIONS_LIST_FAILURE: 'COMMON/GET_CONVERSATIONS_LIST_FAILURE',

  GET_MEMBERS_TO_TRANSFER_GROUP_REQUEST: 'GET_MEMBERS_TO_TRANSFER_GROUP_REQUEST',
  GET_MEMBERS_TO_TRANSFER_GROUP_SUCCESS: 'GET_MEMBERS_TO_TRANSFER_GROUP_SUCCESS',
  GET_MEMBERS_TO_TRANSFER_GROUP_FAILURE: 'GET_MEMBERS_TO_TRANSFER_GROUP_FAILURE',

  SET_TRANSFER_ROLE_DATA: 'COMMON/SET_TRANSFER_ROLE_DATA',

  GET_APP_STORE_VERSIONS_REQUEST: 'COMMON/GET_APP_STORE_VERSIONS_REQUEST',
  GET_APP_STORE_VERSIONS_SUCCESS: 'COMMON/GET_APP_STORE_VERSIONS_SUCCESS',
  GET_APP_STORE_VERSIONS_FAILURE: 'COMMON/GET_APP_STORE_VERSIONS_FAILURE',

  // GET_EXTERNAL_API_CONNECTION_REQUEST: 'COMMON/GET_EXTERNAL_API_CONNECTION_REQUEST',
  // GET_EXTERNAL_API_CONNECTION_SUCCESS: 'COMMON/GET_EXTERNAL_API_CONNECTION_SUCCESS',
  // GET_EXTERNAL_API_CONNECTION_FAILURE: 'COMMON/GET_EXTERNAL_API_CONNECTION_FAILURE',

  // SAVE_EXTERNAL_API_TOKEN_REQUEST: 'COMMON/SAVE_EXTERNAL_API_TOKEN_REQUEST',
  // SAVE_EXTERNAL_API_TOKEN_SUCCESS: 'COMMON/SAVE_EXTERNAL_API_TOKEN_SUCCESS',
  // SAVE_EXTERNAL_API_TOKEN_FAILURE: 'COMMON/SAVE_EXTERNAL_API_TOKEN_FAILURE',

  SET_IS_NATIVE: 'COMMON/SET_IS_NATIVE',
  SET_IS_DESKTOP: 'COMMON/SET_IS_DESKTOP',

  SAVE_FEED_DATA_TO_POST: 'COMMON/SAVE_FEED_DATA_TO_POST',
  REMOVE_FEED_DATA_AFTER_POST: 'COMMON/REMOVE_FEED_DATA_AFTER_POST',

  UPDATE_GDPR_REQUEST: 'COMMON/UPDATE_GDPR_REQUEST',
  UPDATE_GDPR_SUCCESS: 'COMMON/UPDATE_GDPR_SUCCESS',
  UPDATE_GDPR_FAILURE: 'COMMON/UPDATE_GDPR_FAILURE',

  GET_GDPR_REQUEST: 'COMMON/GET_GDPR_REQUEST',
  GET_GDPR_SUCCESS: 'COMMON/GET_GDPR_SUCCESS',
  GET_GDPR_FAILURE: 'COMMON/GET_GDPR_FAILURE',

  GET_TIMEZONES_REQUEST: 'COMMON/GET_TIMEZONES_REQUEST',
  GET_TIMEZONES_SUCCESS: 'COMMON/GET_TIMEZONES_SUCCESS',
  GET_TIMEZONES_FAILURE: 'COMMON/GET_TIMEZONES_FAILURE',

  SET_TIMEZONE: 'COMMON/SET_TIMEZONE',

  DISPLAY_CTA_REQUEST: 'COMMON/DISPLAY_CTA_REQUEST',
  DISPLAY_CTA_SUCCESS: 'COMMON/DISPLAY_CTA_SUCCESS',
  DISPLAY_CTA_FAILURE: 'COMMON/DISPLAY_CTA_FAILURE',

  CLOSE_CTA_REQUEST: 'COMMON/CLOSE_CTA_REQUEST',
  CLOSE_CTA_SUCCESS: 'COMMON/CLOSE_CTA_SUCCESS',
  CLOSE_CTA_FAILURE: 'COMMON/CLOSE_CTA_FAILURE',

  OPEN_CTA_REQUEST: 'COMMON/OPEN_CTA_REQUEST',
  OPEN_CTA_SUCCESS: 'COMMON/OPEN_CTA_SUCCESS',
  OPEN_CTA_FAILURE: 'COMMON/OPEN_CTA_FAILURE'
}
